import { payWall as defaultState } from './default.json';

export default (state = defaultState, action) => {
  const handler = false;
  return handler ? handler(state, action) : state;
};
